import { Route } from 'react-router-dom'

import Products from 'Components/Pages/Products'
import Test from 'Components/Pages/Test'
import Contact from 'Components/Pages/Contact'
import LearnPage from 'Components/Pages/Learn/LearnPage'
import FastingApp from 'Components/Pages/App/FastingApp'
import OrderTrackingPage from 'Components/Elements/OrderTracking/OrderTrackingPage'
import Poc from 'Components/Pages/Poc'
import DirectIntegrateWP from 'Components/Pages/DirectIntegrateWP'
import FaqsPage from 'Components/Pages/FaqsPage'
import ResetPage from 'Components/Pages/ResetPage'

const PublicRoutes = ({ withLoginWrapper }) => [
    <Route key="products" path="/products" element={<Products />} />,
    <Route key="test" path="/test" element={<Test />} />,
    <Route key="contact" path="/contact-us" element={<Contact />} />,
    <Route key="learn" path="/learn" element={<LearnPage />} />,
    <Route key="app" path="/app" element={<FastingApp />} />,
    <Route key="order-tracking" path="/order-tracking" element={withLoginWrapper(<OrderTrackingPage />)} />,
    <Route key="poc" path="/poc" element={<Poc />} />,
    <Route key="direct-wp" path="/direct-wp-poc" element={<DirectIntegrateWP />} />,
    <Route key="faqs" path="/faqs" element={<FaqsPage />} />,
    <Route key="reset" path="/reset" element={<ResetPage />} />
]

export default PublicRoutes

